import { useState, useRef, useEffect, useContext } from "react";
import { Search, MessageSquare, ArrowLeft, Send, RotateCcw, User, Wrench, Shield } from "lucide-react";
import "../../../../assets/css/screens/admin/dashboard/supporttickets/SupportTickets.css";
import AppContext from "../../../../context/AppContext";
import axios from "axios";
import echo from '../../../../config/echo';

const FILTERS = ["all", "open", "in_progress", "resolved"];

const getStatusIcon = (status) => {
  if (status === "open") return <span className="ast-dot ast-dot--open" />;
  if (status === "in_progress") return <span className="ast-dot ast-dot--progress" />;
  if (status === "resolved") return <span className="ast-dot ast-dot--resolved" />;
  return null;
};

const SupportTickets = () => {
  const { baseUrl, baseUrlForFile } = useContext(AppContext);

  const [activeChatId, setActiveChatId] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [reply, setReply] = useState("");
  
  const [Loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(null);
  const [customerMedia, setCustomerMedia] = useState([]);
  const [workerProofs, setWorkerProofs] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewVideo, setPreviewVideo] = useState(null);
  const [conversationId, setConversationId] = useState(null);
  const [chatMode, setChatMode] = useState("support");
const [orderMessages, setOrderMessages] = useState([]);
const [orderConversationId, setOrderConversationId] = useState(null);
  const [sending, setSending] = useState(false);
  const bottomRef = useRef(null);

  // view Tickets
  const viewTickets = async () => {
    axios.get(`${baseUrl}/admin/viewallsupporttickets`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem("authToken") || ""}`
      },
      params: { status: filter },
    })
      .then((response) => {
        setTickets(response.data.supporttickets || []);
      })
      .catch((err) => {
        console.log("API ERROR:", err.response?.data || err.message);
      });
  };

  // view messages
  const viewMessages = async (ticketId) => {
    axios.get(`${baseUrl}/admin/recivechat`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem("authToken") || ""}`
      },
      params: { ticket_id: ticketId }
    })
      .then((response) => {
        console.log("CHAT RESPONSE:", response.data);
        setConversationId(response.data.conversation_id);
        const newMessages = response.data.messages || [];
        setCustomerMedia(response.data.customerMedia || []);
        setWorkerProofs(response.data.workerProofs || []);
        setTickets((prev) =>
          prev.map((ticket) => {
            if (ticket.id !== ticketId) return ticket;
            return {
              ...ticket,
              whconversations: [{
                ...(ticket.whconversations?.[0] || {}),
                whchats: newMessages
              }]
            };
          })
        );
      })
      .catch((err) => {
        setLoading(false);

        console.log(err.response?.data);

      });
  };

  // reply / create chat
  const createChat = async (e) => {
    e.preventDefault();

    // Already sending ho to dobara mat bhejo
    if (sending) return;

    // Blank message mat bhejo
    if (!reply.trim()) return;

    setSending(true);

    const formData = new FormData();
    formData.append("ticket_id", activeChatId);
    formData.append("message", reply.trim());
    formData.append("sender", "admin");
    formData.append("type", "text");

    axios.post(`${baseUrl}/admin/createchat`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        "Content-Type": "multipart/form-data",
      },
    })
     .then((response) => {
  console.log("ADMIN SEND RESPONSE:", response.data);

  if (response.data?.chat) {
    setTickets(prev =>
      prev.map(ticket => {
        if (ticket.id !== activeChatId) return ticket;

        const existingMessages =
          ticket.whconversations?.[0]?.whchats || [];

        // Duplicate message na aaye
        if (
          existingMessages.some(
            msg => msg.id === response.data.chat.id
          )
        ) {
          return ticket;
        }

        return {
          ...ticket,
          whconversations: [{
            ...(ticket.whconversations?.[0] || {}),
            whchats: [
              ...existingMessages,
              response.data.chat
            ]
          }]
        };
      })
    );
  }

  setReply("");
})
      .catch((err) => {
        console.log(err);
        alert("Server Error");
      })
      .finally(() => {
        setSending(false);
      });
  };

  const filtered = tickets.filter((t) => {
    const matchFilter = filter === "all" || t.status === filter;
    const matchSearch =
      t.category?.toLowerCase().includes(search.toLowerCase()) ||
      t.raisedby?.toLowerCase().includes(search.toLowerCase()) ||
      t.against?.toLowerCase().includes(search.toLowerCase());
    return matchFilter && matchSearch;
  });

  useEffect(() => { viewTickets(); }, [filter]);

  useEffect(() => {
    if (activeChatId) bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [activeChatId, tickets]);


  // resolved tickets
const resolveTicket = async (resolvedBy) => {
  if (buttonLoading) return;

  setButtonLoading(resolvedBy);

  try {
    const response = await axios.post(
      `${baseUrl}/subadmin/resolveticket`,
      {
        ticket_id: activeChatId,
        resolved_by: resolvedBy
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    console.log("RESOLVE RESPONSE:", response.data);

    // UI foran update karo
    setTickets((prev) =>
      prev.map((ticket) =>
        ticket.id === activeChatId
          ? {
              ...ticket,
              status: "resolved",
              resolvedBy: resolvedBy
            }
          : ticket
      )
    );

  } catch (err) {
    console.log("RESOLVE ERROR:", err.response?.data || err.message);
  } finally {
    setButtonLoading(null);
  }
};

  const openChat = async (ticket) => {
    setActiveChatId(ticket.id);
    await viewMessages(ticket.id);
  };
const switchToOrderChat = async () => {
  if (buttonLoading) return;

  setButtonLoading("order");

  try {
    const response = await axios.get(
      `${baseUrl}/admin/receiveorderchat`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`
        },
        params: {
          ticket_id: activeChatId
        }
      }
    );

    console.log("ORDER CHAT RESPONSE:", response.data);

    if (!response.data.success) {
      alert(response.data.message || "Order chat not found");
      return;
    }

    setOrderConversationId(response.data.conversation_id);
    setOrderMessages(response.data.messages || []);
    setChatMode("order");

  } catch (err) {
    console.log(
      "ORDER CHAT ERROR:",
      err.response?.data || err.message
    );

    alert(
      err.response?.data?.message ||
      "Unable to load order chat"
    );
  } finally {
    setButtonLoading(null);
  }
};
const switchToSupportChat = () => {
  if (buttonLoading) return;

  setButtonLoading("support");

  setChatMode("support");

  setTimeout(() => {
    setButtonLoading(null);
  }, 300);
};
  useEffect(() => {

    if (!conversationId) return;

    const channel = echo.channel(`conversation-${conversationId}`);

   channel.listen(".ChatMessageSent", (event) => {

  // Ticket Resolve
  if (event.status === "resolved") {

    setTickets(prev =>
      prev.map(ticket =>
        ticket.id === activeChatId
          ? {
              ...ticket,
              status: "resolved",
            }
          : ticket
      )
    );

    return;
  }

  // New Message
  setTickets(prev =>
    prev.map(ticket => {

      if (ticket.id !== activeChatId) return ticket;

      return {
        ...ticket,
        whconversations: [{
          ...(ticket.whconversations?.[0] || {}),
          whchats: [
            ...(ticket.whconversations?.[0]?.whchats || []),
            event.chat
          ]
        }]
      };

    })
  );

});

    return () => {
      echo.leave(`conversation-${conversationId}`);
    };

  }, [conversationId, activeChatId]);
  // ── CHAT VIEW ──
  if (activeChatId) {
    const chat = tickets.find((t) => t.id === activeChatId);
    if (!chat) return null;
const messages =
  chatMode === "order"
    ? orderMessages
    : chat?.whconversations?.[0]?.whchats || [];    const hasCustomerMedia = customerMedia?.length > 0;
    const hasWorkerProofs = workerProofs?.length > 0;

    return (
      <div className="ast-page">
        <div className="ast-chat">

          {/* HEADER */}
          <div className="ast-chat__header">
            <div className="ast-chat__header-left">
              <button className="ast-back-btn" onClick={() => setActiveChatId(null)}>
                <ArrowLeft size={18} />
              </button>

              <div className="ast-chat__header-info">
<h5 className="ast-chat__title">
  {chatMode === "order" ? "Order Chat" : "Dispute Chat"}
</h5>                <div className="ast-chat__meta">
                  <span className="ast-chat__id">{chat.id}</span>
                  <span className="ast-chat__dot">•</span>
                  <span className="ast-chat__user">{chat.raisedby}</span>
                  <span className="ast-chat__user"> Against: {chat.against}</span>
                  <span className={`ast-status-pill ${chat.statusCls}`}>
                    {getStatusIcon(chat.status)}
                    {chat.status}
                    {chat.resolvedBy && (
                      <span className="ast-resolved-by">
                        · to {chat.resolvedBy}
                      </span>
                    )}
                  </span>
                </div>
              </div>
            </div>

            {/* ── 2 Resolve Buttons ── */}
     {chatMode === "support" ? (
  chat.status !== "resolved" && (
    <div className="ast-resolve-btns">

      <button
        className="ast-resolve-btn ast-resolve-btn--worker"
        onClick={() => resolveTicket("worker")}
        disabled={buttonLoading !== null}
      >
        {buttonLoading === "worker" ? (
          "Loading..."
        ) : (
          <>
            <Wrench size={13} /> Resolve to Responder
          </>
        )}
      </button>

      <button
        className="ast-resolve-btn ast-resolve-btn--customer"
        onClick={() => resolveTicket("customer")}
        disabled={buttonLoading !== null}
      >
        {buttonLoading === "customer" ? (
          "Loading..."
        ) : (
          <>
            <User size={13} /> Resolve to Seeker
          </>
        )}
      </button>

      <button
        className="ast-resolve-btn"
        onClick={switchToOrderChat}
        disabled={buttonLoading !== null}
      >
        {buttonLoading === "order" ? (
          "Loading..."
        ) : (
          <>
            <MessageSquare size={13} /> Switch to Order Chat
          </>
        )}
      </button>

    </div>
  )
) : (
  <button
    className="ast-resolve-btn"
    onClick={switchToSupportChat}
    disabled={buttonLoading !== null}
  >
    {buttonLoading === "support" ? (
      "Loading..."
    ) : (
      <>
        <ArrowLeft size={13} /> Switch to Support Chat
      </>
    )}
  </button>
)}
          </div>

          {/* MESSAGES */}
          <div className="ast-chat__messages">
{chatMode === "support" && (hasCustomerMedia || hasWorkerProofs) && (              <div className="ast-dispute-media">

                {hasCustomerMedia && (
                  <div className="ast-media-column">
                    <h5>Customer Uploaded Media</h5>

                    <div className="ast-media-grid">
                      {customerMedia.map((media) => (
                        <img
                          key={media.id}
                          src={`${baseUrlForFile}/${media.file}`}
                          alt=""
                          className="ast-chat-image"
                          onClick={() =>
                            setPreviewImage(`${baseUrlForFile}/${media.file}`)
                          }
                        />
                      ))}
                    </div>
                  </div>
                )}

                {hasWorkerProofs && (
                  <div className="ast-media-column">
                    <h5>Worker Proofs</h5>

                    <div className="ast-media-grid">
                      {workerProofs.map((proof) => {
                        const ext = proof.extension?.toLowerCase();

                        const isVideo = [
                          "mp4",
                          "mov",
                          "avi",
                          "webm",
                          "mkv"
                        ].includes(ext);

                        return isVideo ? (
                          <div
                            key={proof.id}
                            className="ast-video-thumb"
                            onClick={() =>
                              setPreviewVideo(`${baseUrlForFile}/${proof.file}`)
                            }
                          >
                            <video className="ast-chat-image">
                              <source src={`${baseUrlForFile}/${proof.file}`} />
                            </video>

                            <div className="ast-play-icon">▶</div>
                          </div>
                        ) : (
                          <img
                            key={proof.id}
                            src={`${baseUrlForFile}/${proof.file}`}
                            alt=""
                            className="ast-chat-image"
                            onClick={() =>
                              setPreviewImage(`${baseUrlForFile}/${proof.file}`)
                            }
                          />
                        );
                      })}
                    </div>
                  </div>
                )}

              </div>
            )}
            {messages?.filter((msg) => msg)?.map((msg, index) => (
              <div
                key={msg?.id || index}
                className={`ast-msg ${msg?.sender === "admin"
                  ? "ast-msg--admin"
                  : msg?.sender === "customer"
                    ? "ast-msg--user"
                    : msg?.sender === "worker"
                      ? "ast-msg--worker"
                      : "ast-msg--user"
                  }`}
              >
                {/* Sender label outside bubble for non-admin */}
                {msg?.sender !== "admin" && (
                  <div className={`ast-msg__avatar ast-msg__avatar--${msg?.sender}`}>
                    {msg?.sender === "worker"
                      ? <Wrench size={14} />
                      : <User size={14} />
                    }
                  </div>
                )}
                <div className="ast-msg__bubble">

                  <div className="ast-msg__top">
                    <span className="ast-msg__sender">{msg?.sender}</span>
                  </div>

                  {msg?.message && (
                    <p className="ast-msg__text">{msg.message}</p>
                  )}

                  {msg?.file && (
                    <img
                      src={`${baseUrlForFile}/${msg.file}`}
                      alt="attachment"
                      className="ast-chat-image"
                    />
                  )}

                </div>
              </div>
            ))}
            <div ref={bottomRef} />
          </div>
          {previewImage && (
            <div
              className="ast-image-modal"
              onClick={() => setPreviewImage(null)}
            >
              <button
                className="ast-modal-close"
                onClick={() => setPreviewImage(null)}
              >
                ✕
              </button>

              <img
                src={previewImage}
                alt="Preview"
                className="ast-image-modal-img"
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          )}

          {previewVideo && (
            <div
              className="ast-image-modal"
              onClick={() => setPreviewVideo(null)}
            >
              <button
                className="ast-modal-close"
                onClick={() => setPreviewVideo(null)}
              >
                ✕
              </button>

              <video
                controls
                autoPlay
                className="ast-video-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <source src={previewVideo} />
              </video>
            </div>
          )}
          {/* REPLY */}
          {/* REPLY */}
        {chatMode === "order" ? (
  <div className="ast-chat__footer">
   <div className="ast-order-readonly-text">
  Order Chat is read-only. You can only view messages.
</div>
  </div>
) : chat.status !== "resolved" ? (
  <div className="ast-chat__footer"> 
    <input 
      className="ast-reply-input" 
      value={reply} 
      onChange={(e) => setReply(e.target.value)} 
      onKeyDown={(e) => { 
        if (e.key === "Enter" && !sending && reply.trim()) { 
          createChat(e); 
        } 
      }} 
      placeholder="Type your reply..." 
    /> 
 
    <button 
      className="ast-send-btn" 
      onClick={createChat} 
      disabled={sending || !reply.trim()} 
    > 
      {sending ? ( 
        "Sending..." 
      ) : ( 
        <> 
          <Send size={15} /> Send 
        </> 
      )} 
    </button> 
  </div> 
) : ( 
  <div className="ast-ticket-resolved"> 
    <span className="ast-ticket-resolved__badge"> 
      ✅ Ticket resolved {chat.resolvedBy && `to ${chat.resolvedBy}`} 
    </span> 
  </div> 
)}

        </div>
      </div>
    );
  }

  // ── LIST VIEW ──
  return (
    <div className="ast-page">
      <div className="ast-header">
        <div className="ast-header__left">
          <h2 className="ast-heading">Support Tickets</h2>
          <p className="ast-subtext">Manage user support requests</p>
        </div>
        <div className="ast-search-wrap">
          <Search size={15} className="ast-search-icon" />
          <input
            className="ast-search-input"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search tickets..."
          />
        </div>
      </div>

      <div className="ast-filters">
        {FILTERS.map((f) => (
          <button
            key={f}
            className={`ast-filter-btn ${filter === f ? "ast-filter-btn--active" : ""}`}
            onClick={() => setFilter(f)}
          >
            {f}
          </button>
        ))}
      </div>

      <div className="ast-list">
        {filtered.map((ticket, i) => (
          <div className="ast-ticket" key={ticket.id} style={{ animationDelay: `${i * 0.07}s` }}>
            <div className="ast-ticket__left">
              <div className="ast-ticket__icon-wrap">
                {getStatusIcon(ticket.status)}
              </div>
              <div className="ast-ticket__info">
                <div className="ast-ticket__top">
                  <span className="ast-ticket__id">#{ticket.id}</span>
                  <span className="ast-status-pill">
                    {getStatusIcon(ticket.status)}
                    {ticket.status}
                  </span>
                </div>
                <p className="ast-ticket__title">{ticket.category}</p>
                <p className="ast-ticket__desc">{ticket.description}</p>
                <div className="ast-ticket__bottom">
                  <span className="ast-ticket__user">Raised By: {ticket.raisedby}</span>
                  <span className="ast-ticket__sep">•</span>
                  <span className="ast-ticket__user">Against: {ticket.against}</span>
                </div>
              </div>
            </div>
            <button className="ast-chat-btn" onClick={() => openChat(ticket)}>
              <MessageSquare size={14} /> Chat
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SupportTickets;